import React from 'react'
import { Card, CardBody } from 'reactstrap'

// const ComplianceCard = this.props => {
class HighLevelCard extends React.Component {
  render () {
    let classes = ' white-border-card '
    if (this.props.hoverColor) {
      classes += ' card-hover '
    }
    if (this.props.isActive) {
      classes = 'compliance-card-active '
    }

    return (

      <Card style={this.props.clickable ? { cursor: 'pointer' } : {}}>
        <CardBody className={classes + this.props.bgColor}
        >
          {
            this.props.title
              ? <h3 style={{ fontSize: '20px', fontWeight: '600' }}>{this.props.title}</h3>
              : this.props.category
                ? <h5 style={{ height: 30 }}>{this.props.category}</h5>
                : null
          }
          <div style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignContent: 'center',
            alignItems: 'center'
          }}>
            <div style={{
              fontSize: 50,
              color: this.props.percentage_color,
              paddingRight: 20
            }}>
              {this.props.percentage}
            </div>
            <div style={{
              fontSize: 14,
              fontWeight: 200,
              paddingLeft: 25,
              color: 'grey',
              borderLeft: '2px solid #D9DBDC'
            }}>
              {this.props.description}</div>
          </div>
        </CardBody>
      </Card>
    )
  }
}

export default HighLevelCard



// WEBPACK FOOTER //
// ./src/components/compliance/components/HighLevelCard.js